// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".a-popover[data-v-32e89246]{min-width:180px;pointer-events:none;background:#fff;border-radius:5px;box-shadow:0 0 10px 0 rgba(0,0,0,.15);opacity:0;transition:opacity .3s}.a-popover--show[data-v-32e89246]{pointer-events:auto;opacity:1}", ""]);
// Exports
module.exports = exports;
